import Cookies from 'js-cookie';
import { Options } from 'ky';

import { query } from '@/constants/query';
import { retryRequest, setAuthToken } from '@/utils/requestHooks';

import { ServiceBase } from '../base';

class ServiceDev extends ServiceBase {
  get options(): Options {
    return {
      hooks: {
        beforeRequest: [
          setAuthToken(async (request) => {
            if (request.url.includes('/auth')) return;

            await this.refreshToken();
            return Cookies.get(query.auth);
          }),
        ],
        afterResponse: [
          retryRequest({
            retry: async (...args) => {
              const [request] = args;
              if (request.url.includes('/auth')) return;
              return this.api.http(...args).json();
            },
            refreshToken: async (request) => {
              if (request.url.includes('/auth')) return;
              return this.refreshToken();
            },
          }),
        ],
      },
    };
  }

  async auth() {
    return await super.auth();
  }
}

export default ServiceDev;
